import React from "react";
import { secondaryTextColorOppositeShade } from "../../utils/constants";

export default function TPOptimizationIcon({ color = secondaryTextColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82.99 82.99">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <path
            fill={color}
            d="M58.19,18.89a2.09,2.09,0,0,0-2.95,0L.61,73.52a2.09,2.09,0,0,0,0,3h0l5.91,5.91a2.09,2.09,0,0,0,3,0L64.1,27.75a2.09,2.09,0,0,0,0-2.95ZM8,78,5,75,47.86,32.18l3,3ZM53.76,32.18l-2.95-2.95,5.9-5.91,3,3Z"
          />
          <path fill={color} d="M45.79,16.53a2.09,2.09,0,0,0,3-3l-5.9-5.91a2.09,2.09,0,0,0-3,2.91s0,0,0,.05Z" />
          <path fill={color} d="M69.41,34.25a2.09,2.09,0,0,0-3,2.9l0,.05,5.9,5.91a2.09,2.09,0,0,0,3-2.92l0,0Z" />
          <path
            fill={color}
            d="M68.52,16.55A2.09,2.09,0,0,0,70,15.94L75.9,10a2.09,2.09,0,0,0-3-2.95L67.05,13a2.09,2.09,0,0,0,1.47,3.56Z"
          />
          <path fill={color} d="M32.52,25.41h8.36a2.09,2.09,0,0,0,0-4.17H32.52a2.09,2.09,0,0,0,0,4.17Z" />
          <path fill={color} d="M80.9,24.19H72.55a2.09,2.09,0,1,0,0,4.17H80.9a2.09,2.09,0,1,0,0-4.17Z" />
          <path
            fill={color}
            d="M56.71,12.53a2.09,2.09,0,0,0,2.09-2.09V2.09a2.09,2.09,0,1,0-4.17,0v8.35a2.09,2.09,0,0,0,2.08,2.09Z"
          />
          <path
            fill={color}
            d="M59.67,40a2.08,2.08,0,0,0-2.09,2.08h0v8.36a2.09,2.09,0,0,0,4.17,0V42.11A2.07,2.07,0,0,0,59.67,40Z"
          />
        </g>
      </g>
    </svg>
  );
}
